import { render } from "./SlimSoft.vue?vue&type=template&id=707bc9ce&scoped=true"
import script from "./SlimSoft.vue?vue&type=script&lang=js"
export * from "./SlimSoft.vue?vue&type=script&lang=js"

import "./SlimSoft.vue?vue&type=style&index=0&id=707bc9ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707bc9ce"]])

export default __exports__